import { Row } from 'antd';
import Table from 'components/Table';
import { ITableProps, MobileTableType } from 'components/Table/types';
import useWindowSize from 'hooks/useWindowSize';
import React from 'react';
import { useHistory } from 'react-router';
import ROUTES from 'routes/routeConstants';
import { GeneralFunction } from 'types/common';
import { ITransaction } from 'types/transaction';
import { getLink } from 'utils';

import NestedScheduleList from './NestedScheduleList';
import { ITransactionListTableProps } from './types';

// const DESIGN_TYPES = {
//   GRID: 'grid',
//   TABLE: 'table',
// };
// const CURRENT_DESIGN = DESIGN_TYPES.TABLE;

const TransactionList: React.FC<
  ITableProps<ITransactionListTableProps> & { refetchTransactionList?: GeneralFunction }
> = (tableProps) => {
  const history = useHistory();

  const onRowClick = (transaction?: ITransaction) => {
    if (transaction) {
      history.push(getLink(ROUTES.TRANSACTION_DETAIL, { id: transaction.id }));
    }
  };

  const mobileThreshold = 768;
  const { isMobile } = useWindowSize(mobileThreshold);

  return (
    // if (error) return <p>Error :(</p>;
    <Row style={{ width: '100%', margin: 0, height: '100%', padding: isMobile ? 16 : undefined }}>
      <Table
        // rowClassName={(record, index) => (index % 2 !== 0 ? 'odd-row' : 'even-row')}
        {...tableProps}
        expandable={{
          expandedRowRender: (data: ITransactionListTableProps) => <NestedScheduleList data={data} />,
        }}
        onRow={(record) => ({
          onClick: () => {
            onRowClick(record.transaction);
            // setActiveUserId(record.key);
            // setDrawerVisibility(true);
          },
        })}
        widthThreshold={mobileThreshold}
        className='gx-table-responsive gx-custom-table'
        mobileDesignType={MobileTableType.RESPONSIVE_TABLE}
      />
    </Row>
  );
};
export default React.memo(TransactionList);
